import {Modal, Spinner} from 'react-bootstrap'

import {useEffect, useMemo, useState} from 'react'
import {CardElement, AuBankAccountElement, useElements, useStripe} from '@stripe/react-stripe-js'

import axios from 'axios'
import {useDispatch, useSelector} from 'react-redux'
import {toast} from 'react-toastify'
import './virtualmenber.scss'
import {defaultRegion, KTSVG} from '../../../../../_metronic/helpers'
import WSButton from '../../../../../_metronic/helpers/components/WSButton/WSButton'
import {GetCardList} from '../../../../Redux/AdminPanel/PurchaseCreditSlice'
import {startLoadding, stopLoading} from '../../../../Redux/FrontEnd/Loading/LoadingSlice'
import {
  getAvailableDedicatedNumberToPurchase,
  getDedicatedNumberList,
  getDedicatedNumberListToBuy,
} from './DedicatedNumberSlice/DedicatedNumberSlice'
import {useBuyCreditMutation} from '../../../../../services/cellcast.v3'
import {
  useLazyGetDnGracePeriodSettingQuery,
  useLazyGetDnCustomPriceSettingQuery,
} from '../../../../../services/cellcast'
import {GetCurrentData} from '../../../../Utils/_helpers/GetCurrentData'
import {BuyCreditParam} from '../../../../../services/cellcast.v3.types'
import {ENV} from '../../../../Utils/_helpers/EnvHelper'
import {toNumber, shuffle, take, get} from 'lodash'
import {addTax} from '../../../../Utils/_helpers'

import {getDefaultRegion} from '../../accounts/Overview/OverviewSlice/UserDetailsSlice'
import {
  MessageType,
  NUMBER_TYPE,
  REGION,
  typeMessageMap,
} from '../../../../Utils/Constant/ConstantForWebsite'

interface modalTypes {
  show: boolean
  handleClose: () => void
  dedicatedNumber?: any
  resubscribe?: boolean
}
const CARD_OPTIONS: any = {
  iconStyle: 'solid',
  hidePostalCode: true,
  style: {
    base: {
      color: '#303238',
      fontSize: '16px',
      fontFamily: 'sans-serif',
      fontSmoothing: 'antialiased',
      '::placeholder': {
        color: '#CFD7DF',
      },
    },
    invalid: {
      color: '#e5424d',
      ':focus': {
        color: '#303238',
      },
    },
  },
}

const AU_BANK_ACCOUNT_OPTIONS: any = {
  style: {
    base: {
      color: '#303238',
      fontSize: '16px',
      fontFamily: 'sans-serif',
      fontSmoothing: 'antialiased',
      '::placeholder': {
        color: '#CFD7DF',
      },
    },
    invalid: {
      color: '#e5424d',
      ':focus': {
        color: '#303238',
      },
    },
  },
}

const VirtualNumbersModal = ({show, handleClose, dedicatedNumber, resubscribe}: modalTypes) => {
  const API_URL = ENV().REACT_APP_API_URL
  const [buyCredit] = useBuyCreditMutation()
  const [getDnGracePeriodSetting] = useLazyGetDnGracePeriodSettingQuery()
  const [getDnCustomPriceSetting] = useLazyGetDnCustomPriceSettingQuery()
  const currentUser = GetCurrentData()

  const dispatch = useDispatch()
  const [name, setName] = useState('')
  const [error, setError] = useState('')
  const [next, setNext] = useState<any>(1)
  const [errors, setErrors] = useState<any>({
    number: '',
    plan: '',
  })
  const [success, setSuccess] = useState(true)
  const [complete, setComplete] = useState(false)
  const [cardID, setCardID] = useState<any>('')
  const [successPopup, setsuccessPopup] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [paymentMethod, setPaymentMethod] = useState<'card' | 'au_becs_debit'>('card')
  const [accountHolderName, setAccountHolderName] = useState('')
  const [email, setEmail] = useState('')
  const [becsComplete, setBecsComplete] = useState(false)
  const [dnGracePeriodEnabled, setDnGracePeriodEnabled] = useState(false)
  const [customPrice, setCustomPrice] = useState<{
    status: string
    monthly?: number
    yearly?: number
  } | null>(null)
  const stripe: any = useStripe()
  const elements: any = useElements()
  const [buyNumber, setBuyNumber] = useState({
    type: NUMBER_TYPE.MMS,
    number: '',
    product: '',
    price: 0,
    recurring_time: '',
    selected: '',
  })
  const [plan, setPlan] = useState<any>()
  const dedicatedNumberList = useSelector(getDedicatedNumberListToBuy)
  const cards = useSelector((state: any) => state?.productList?.cardList)

  const userRegion = useSelector(getDefaultRegion)

  useEffect(() => {
    setIsLoading(true)
    dispatch(getAvailableDedicatedNumberToPurchase()).finally(() => setIsLoading(false))
    dispatch(GetCardList())
  }, [])

  useEffect(() => {
    // Fetch DN Grace Period setting
    if (currentUser?._id) {
      getDnGracePeriodSetting({userId: currentUser._id})
        .unwrap()
        .then((res) => {
          if (res.data) {
            setDnGracePeriodEnabled(res.data?.status)
          }
        })
        .catch((err) => {
          console.error('Failed to fetch DN Grace Period setting:', err)
          setDnGracePeriodEnabled(false)
        })
    }
  }, [currentUser?._id, getDnGracePeriodSetting])

  useEffect(() => {
    // Fetch DN Custom Price setting
    if (currentUser?._id) {
      getDnCustomPriceSetting({userId: currentUser._id})
        .unwrap()
        .then((res) => {
          if (res.data) {
            setCustomPrice(res.data)
          }
        })
        .catch((err) => {
          console.error('Failed to fetch DN Custom Price setting:', err)
          setCustomPrice(null)
        })
    }
  }, [currentUser?._id, getDnCustomPriceSetting])

  const listNumber = useMemo(() => take(shuffle(dedicatedNumberList), 30), [
    dedicatedNumberList,
    resubscribe,
  ])

  useEffect(() => {
    let paymenttype = listNumber?.find((key: any) => key?._id == buyNumber?.number)

    if (resubscribe) {
      paymenttype = dedicatedNumber?.find((key: any) => key?._id == buyNumber?.number)
    }

    setPlan(paymenttype)
  }, [buyNumber?.number, dedicatedNumber, resubscribe])

  const handleCheckout = async (e: any) => {
    try {
      if (!buyNumber?.product) {
        toast.error('Please select a valid plan')
        return
      }
      dispatch(startLoadding())

      if (cardID) {
        let responce = await axios
          .post(
            `${API_URL}user/subscribeDedicatedNumbers`,
            {
              card: cardID,
              product: buyNumber?.product,
              price: buyNumber?.price,
              number: buyNumber?.number,
              recurring_time: buyNumber?.recurring_time,
              resubscribe,
            },
            {
              headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
            }
          )
          .then((res: any) => {
            if (res?.status == 200) {
              dispatch(stopLoading())
              dispatch(getDedicatedNumberList())
              dispatch(getAvailableDedicatedNumberToPurchase())
              setSuccess(true)
              setsuccessPopup(true)
              setBuyNumber({
                type: NUMBER_TYPE.SMS,
                number: '',
                product: '',
                price: 0,
                recurring_time: '',
                selected: '',
              })
              setNext(1)
              setErrors({
                number: '',
                plan: '',
              })
              handleClose()
              toast.success(res?.data?.message)
            } else {
              dispatch(stopLoading())
              handleClose()
              setBuyNumber({
                type: NUMBER_TYPE.SMS,
                number: '',
                product: '',
                price: 0,
                recurring_time: '',
                selected: '',
              })
              setNext(1)
              setErrors({
                number: '',
                plan: '',
              })
              toast.error(res?.data?.message)
            }
          })
          .catch((err: any) => {
            dispatch(stopLoading())
            handleClose()
            setBuyNumber({
              type: NUMBER_TYPE.SMS,
              number: '',
              product: '',
              price: 0,
              recurring_time: '',
              selected: '',
            })
            setNext(1)
            setErrors({
              number: '',
              plan: '',
            })
            toast.error('Payment Fail')
          })
      } else {
        if (elements == null) {
          return
        }

        if (paymentMethod === 'au_becs_debit') {
          // BECS Direct Debit Payment Method
          const auBankAccountElement = elements.getElement(AuBankAccountElement)

          const {error, paymentMethod: becsPaymentMethod} = await stripe.createPaymentMethod({
            type: 'au_becs_debit',
            au_becs_debit: auBankAccountElement,
            billing_details: {
              name: accountHolderName,
              email: email,
            },
          })

          if (!error && becsPaymentMethod) {
            axios
              .post(
                `${API_URL}user/subscribeDedicatedNumbers`,
                {
                  payment_method: becsPaymentMethod.id,
                  payment_method_type: 'au_becs_debit',
                  product: buyNumber?.product,
                  price: buyNumber?.price,
                  number: buyNumber?.number,
                  recurring_time: buyNumber?.recurring_time,
                  resubscribe,
                },
                {
                  headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
                }
              )
              .then((res: any) => {
                res?.status == 200 && dispatch(stopLoading())
                dispatch(getDedicatedNumberList())
                dispatch(getAvailableDedicatedNumberToPurchase())
                setSuccess(true)
                setsuccessPopup(true)
                handleClose()
                setBuyNumber({
                  type: NUMBER_TYPE.SMS,
                  number: '',
                  product: '',
                  price: 0,
                  recurring_time: '',
                  selected: '',
                })
                setNext(1)
                setErrors({
                  number: '',
                  plan: '',
                })
                toast.success(res?.data?.message)
              })
              .catch((err: any) => {
                dispatch(stopLoading())
                handleClose()
                setBuyNumber({
                  type: NUMBER_TYPE.SMS,
                  number: '',
                  product: '',
                  price: 0,
                  recurring_time: '',
                  selected: '',
                })
                setNext(1)
                setErrors({
                  number: '',
                  plan: '',
                })

                toast.error('Payment Fail')
              })
          } else {
            toast.error(error?.message ?? 'Payment fail')
            dispatch(stopLoading())
          }
        } else {
          // Card Payment Method
          const cardElement = elements.getElement('card', {name})
          const token = await stripe.createToken(cardElement)
          const {error, paymentMethod} = await stripe.createPaymentMethod({
            type: 'card',
            card: elements.getElement(CardElement),
            billing_details: {
              name,
            },
          })

          if (!error) {
            axios
              .post(
                `${API_URL}user/subscribeDedicatedNumbers`,
                {
                  token: token?.token?.id,
                  product: buyNumber?.product,
                  price: buyNumber?.price,
                  number: buyNumber?.number,
                  recurring_time: buyNumber?.recurring_time,
                  resubscribe,
                },
                {
                  headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
                }
              )
              .then((res: any) => {
                res?.status == 200 && dispatch(stopLoading())
                dispatch(getDedicatedNumberList())
                dispatch(getAvailableDedicatedNumberToPurchase())
                setSuccess(true)
                setsuccessPopup(true)
                handleClose()
                setBuyNumber({
                  type: NUMBER_TYPE.SMS,
                  number: '',
                  product: '',
                  price: 0,
                  recurring_time: '',
                  selected: '',
                })
                setNext(1)
                setErrors({
                  number: '',
                  plan: '',
                })
                toast.success(res?.data?.message)
              })
              .catch((err: any) => {
                dispatch(stopLoading())
                handleClose()
                setBuyNumber({
                  type: NUMBER_TYPE.SMS,
                  number: '',
                  product: '',
                  price: 0,
                  recurring_time: '',
                  selected: '',
                })
                setNext(1)
                setErrors({
                  number: '',
                  plan: '',
                })

                toast.error('Payment Fail')
              })
          } else {
            toast.error(error?.message ?? 'Payment fail')
            dispatch(stopLoading())
          }
        }
      }
    } catch (error) {
      console.log('errorerrorerror', error)
      toast.error('Stripe Failed to load!')
      dispatch(stopLoading())
    }
  }

  const handleSubmit = async (e: any) => {
    e.preventDefault()
    if (currentUser?.region === defaultRegion) {
      handleCheckout(e)
      return
    }
    try {
      if (!buyNumber?.product) {
        toast.error('Please select a valid plan')
        return
      }
      dispatch(startLoadding())

      if (cardID) {
        const param: BuyCreditParam = {
          card: cardID,
          product: buyNumber?.product,
          price: buyNumber?.price,
          number: buyNumber?.number,
          recurring_time: buyNumber?.recurring_time,
        }
        const result = await buyCredit({
          action: 'buy_credit',
          data: param,
        }).unwrap()

        if (result) {
          dispatch(stopLoading())
          dispatch(getDedicatedNumberList())
          dispatch(getAvailableDedicatedNumberToPurchase())
          setSuccess(true)
          setsuccessPopup(true)
          handleClose()
          setBuyNumber({
            type: NUMBER_TYPE.SMS,
            number: '',
            product: '',
            price: 0,
            recurring_time: '',
            selected: '',
          })
          setNext(1)
          setErrors({
            number: '',
            plan: '',
          })
        } else {
          dispatch(stopLoading())
          handleClose()
          setBuyNumber({
            type: NUMBER_TYPE.SMS,
            number: '',
            product: '',
            price: 0,
            recurring_time: '',
            selected: '',
          })
          setNext(1)
          setErrors({
            number: '',
            plan: '',
          })

          toast.error('Payment Fail')
        }
      } else {
        if (elements == null) {
          return
        }

        if (paymentMethod === 'au_becs_debit') {
          // BECS Direct Debit Payment Method
          const auBankAccountElement = elements.getElement(AuBankAccountElement)

          const {error, paymentMethod: becsPaymentMethod} = await stripe.createPaymentMethod({
            type: 'au_becs_debit',
            au_becs_debit: auBankAccountElement,
            billing_details: {
              name: accountHolderName,
              email: email,
            },
          })

          if (!error && becsPaymentMethod) {
            const param: BuyCreditParam = {
              product: buyNumber?.product,
              price: buyNumber?.price,
              number: buyNumber?.number,
              recurring_time: buyNumber?.recurring_time,
              card: cardID,
              payment_method: becsPaymentMethod.id,
              payment_method_type: 'au_becs_debit',
            }
            const result = await buyCredit({
              action: 'buy_credit',
              data: param,
            }).unwrap()

            if (result) {
              dispatch(getDedicatedNumberList())
              dispatch(getAvailableDedicatedNumberToPurchase())
              setSuccess(true)
              setsuccessPopup(true)
              handleClose()
              setBuyNumber({
                type: NUMBER_TYPE.SMS,
                number: '',
                product: '',
                price: 0,
                recurring_time: '',
                selected: '',
              })
              setNext(1)
              setErrors({
                number: '',
                plan: '',
              })
            } else {
              dispatch(stopLoading())
              handleClose()
              setBuyNumber({
                type: NUMBER_TYPE.SMS,
                number: '',
                product: '',
                price: 0,
                recurring_time: '',
                selected: '',
              })
              setNext(1)
              setErrors({
                number: '',
                plan: '',
              })

              toast.error('Payment Fail')
            }
          } else {
            console.log('errorerrorerror', error)
            toast.error(error?.message ?? 'Payment fail')
            dispatch(stopLoading())
          }
        } else {
          // Card Payment Method
          const cardElement = elements.getElement('card')

          const token = await stripe.createToken(cardElement, {name})
          const {error} = await stripe.createPaymentMethod({
            type: 'card',
            card: elements.getElement(CardElement),
            billing_details: {
              name,
            },
          })

          if (!error) {
            const param: BuyCreditParam = {
              product: buyNumber?.product,
              price: buyNumber?.price,
              number: buyNumber?.number,
              recurring_time: buyNumber?.recurring_time,
              card: cardID,
              token: token?.token?.id,
            }
            const result = await buyCredit({
              action: 'buy_credit',
              data: param,
            }).unwrap()

            if (result) {
              dispatch(getDedicatedNumberList())
              dispatch(getAvailableDedicatedNumberToPurchase())
              setSuccess(true)
              setsuccessPopup(true)
              handleClose()
              setBuyNumber({
                type: NUMBER_TYPE.SMS,
                number: '',
                product: '',
                price: 0,
                recurring_time: '',
                selected: '',
              })
              setNext(1)
              setErrors({
                number: '',
                plan: '',
              })
            } else {
              dispatch(stopLoading())
              handleClose()
              setBuyNumber({
                type: NUMBER_TYPE.SMS,
                number: '',
                product: '',
                price: 0,
                recurring_time: '',
                selected: '',
              })
              setNext(1)
              setErrors({
                number: '',
                plan: '',
              })

              toast.error('Payment Fail')
            }
          } else {
            console.log('errorerrorerror', error)
            toast.error(error?.message ?? 'Payment fail')
            dispatch(stopLoading())
          }
        }
      }
    } catch (error) {
      console.log('errorerrorerror', error)
      toast.error('Stripe Failed to load!')
      dispatch(stopLoading())
    }
  }

  const handleClick = () => {
    if (buyNumber.number !== '' && buyNumber?.product !== '') {
      setNext(2)
    } else {
      const err: any = {}

      if (buyNumber.number == '') {
        err.number = 'please select one number'
      }
      if (buyNumber.product == '') {
        err.plan = 'please select plan'
      }
      if (buyNumber.recurring_time == '') {
        err.plan = 'please select plan'
      }
      if (buyNumber.price == 0) {
        err.plan = 'please select plan'
      }
      setErrors({...errors, ...err})
    }
  }

  const numberList = resubscribe ? dedicatedNumber : listNumber

  return (
    <>
      {/* <SuccessPopup
        button={[{name: 'My Dedicated Number', path: `accounts/sender-id's`}]}
        show={successPopup}
        handleClose={() => {
          setsuccessPopup(false)
        }}
      /> */}
      <Modal
        id='kt_modal_create_app'
        tabIndex={-1}
        aria-hidden='true'
        dialogClassName='modal-dialog-centered mw-1000px h-auto common-modalpopup payment_modal'
        show={show}
        onHide={() => {
          setBuyNumber({
            type: NUMBER_TYPE.SMS,
            number: '',
            product: '',
            price: 0,
            recurring_time: '',
            selected: '',
          })
          setNext(1)
          setErrors({
            number: '',
            plan: '',
          })
          handleClose()
        }}
      >
        <div className='container-xxl p-0'>
          <div className='modal-header'>
            <h2 className='fs-2'>Purchase dedicated number</h2>
            <div
              className='btn btn-icon btn-sm'
              onClick={() => {
                handleClose()
                setBuyNumber({
                  type: NUMBER_TYPE.SMS,
                  number: '',
                  product: '',
                  price: 0,
                  recurring_time: '',
                  selected: '',
                })
                setNext(1)
                setErrors({
                  number: '',
                  plan: '',
                })
                setNext(1)
              }}
            >
              <KTSVG className='svg-icon-1' path='/media/icons/duotune/arrows/arr061.svg' />
            </div>
          </div>
          <div className='modal-body border-bottom'>
            <div className='mb-10'></div>
            <div className='row'>
              <div className='col-lg-5'>
                <div className='number-wrap'>
                  <ul>
                    <li className={next >= 1 ? 'active' : ''}>
                      <span className='dedicatednumber-step'>
                        <div className='number'>
                          <span className='count'>1</span>
                          {/* <span className='icon'>
                            <span className='svg-icon'>
                              <svg
                                width='13'
                                height='10'
                                viewBox='0 0 13 10'
                                fill='none'
                                xmlns='http://www.w3.org/2000/svg'
                              >
                                <path
                                  d='M1 4L5 8L11.5 1'
                                  stroke='#7950f2'
                                  stroke-width='2'
                                  stroke-linecap='round'
                                />
                              </svg>
                            </span>
                          </span> */}
                        </div>
                        <div className='number-right-content'>
                          <h4>Dedicated number</h4>
                          <p>choose DN and plan</p>
                        </div>
                      </span>
                    </li>
                    <li className={next === 2 ? 'active' : ''}>
                      <span className='dedicatednumber-step'>
                        <div className='number'>
                          <span className='count'>2</span>
                        </div>
                        <div className='number-right-content'>
                          <h4>Billing</h4>
                          <p>Purchase information</p>
                        </div>
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
              {next === 1 && (
                <div className='col-lg-7'>
                  <div className='virtual-detail-wrap'>
                    <div className='badge-main'>
                      <h5 className='heading'>
                        What would you like to use your dedicated number for?
                      </h5>
                      {resubscribe &&
                      numberList?.length &&
                      numberList?.filter(
                        (key: any) => key?.type.toUpperCase() === NUMBER_TYPE.SMS
                      ) ? (
                        <span className='symbol-label me-3'>
                          <button
                            onClick={() => {
                              setBuyNumber({...buyNumber, type: NUMBER_TYPE.SMS, number: ''})
                              setErrors({
                                number: '',
                                plan: '',
                              })
                            }}
                            className={`btn btn-lg px-8 py-3 fs-5 ${
                              buyNumber?.type === NUMBER_TYPE.SMS
                                ? 'btn-primary'
                                : 'btn-secondary text-primary'
                            }`}
                          >
                            SMS
                          </button>
                        </span>
                      ) : null}

                      <span className='symbol-label me-3'>
                        <button
                          onClick={() => {
                            setBuyNumber({...buyNumber, type: NUMBER_TYPE.MMS, number: ''})
                            setErrors({
                              number: '',
                              plan: '',
                            })
                          }}
                          className={`btn btn-lg px-8 py-3 fs-5 ${
                            buyNumber?.type === NUMBER_TYPE.MMS
                              ? 'btn-primary'
                              : 'btn-secondary text-primary'
                          }`}
                        >
                          SMS + MMS
                        </button>
                      </span>
                      <span className='symbol-label me-3'>
                        <button
                          onClick={() => {
                            setBuyNumber({...buyNumber, type: NUMBER_TYPE.VOICE, number: ''})
                            setErrors({
                              number: '',
                              plan: '',
                            })
                          }}
                          className={`btn btn-lg px-8 py-3 fs-5 ${
                            buyNumber?.type === NUMBER_TYPE.VOICE
                              ? 'btn-primary'
                              : 'btn-secondary text-primary'
                          }`}
                        >
                          SMS + Voice
                        </button>
                      </span>
                    </div>
                    <h5 className='heading'>Choose your dedicated number</h5>
                    <p className='content-p'>
                      If you require a specific number, speak with your account manager
                    </p>
                    <div className='contact-detail'>
                      <div className='btn-wrap-check'>
                        {isLoading ? (
                          <div className='d-flex m-auto justify-content-center align-items-center'>
                            <Spinner variant='primary' animation='grow' /> Loading....
                          </div>
                        ) : (
                          numberList
                            ?.filter((key: any) => key?.type.toUpperCase() === buyNumber?.type)
                            .slice(0, 4)
                            ?.map((key: any, id: any) => {
                              return (
                                key?.type.toUpperCase() == buyNumber?.type && (
                                  <label key={id} className='custom-radio'>
                                    {key?.audNumber}
                                    <input
                                      checked={buyNumber?.number == key?._id}
                                      onChange={() => {
                                        setBuyNumber({...buyNumber, number: key?._id})
                                      }}
                                      type='radio'
                                    />
                                    <span className='checkmark'></span>
                                  </label>
                                )
                              )
                            })
                        )}
                      </div>
                      {errors.number !== '' && <span className='text-danger'>{errors.number}</span>}
                    </div>

                    {buyNumber?.number && (
                      <div className='payment-wrap'>
                        <label className='form-label'>Payment plan</label>
                        <select
                          onChange={(e) => {
                            setErrors({
                              ...errors,
                              plan: '',
                            })

                            e.target.value !== ''
                              ? setBuyNumber({
                                  ...buyNumber,
                                  price: toNumber(e.target.value.split('-')[1]),
                                  recurring_time: e.target.value.split('-')[0],
                                  product: e.target.value.split('-')[2],
                                  selected: e.target.value,
                                })
                              : setBuyNumber({...buyNumber, price: 0, product: ''})
                          }}
                          className='form-select bg-light-primary border-0'
                        >
                          <option value={''}>Select plan</option>
                          {/* <option value={`day-1-prod_PIcEaE9jV6BQYa`}>Daily - $1</option> */}
                          {resubscribe ? (
                            <>
                              <option
                                value={`month-${
                                  customPrice?.status === 'active' && customPrice?.monthly != null
                                    ? customPrice.monthly
                                    : plan?.gateway?.DNmonthly
                                }-${plan?.gateway?.monthly_stripe_prod_id}`}
                              >
                                Monthly (subscription) - $
                                {addTax(
                                  customPrice?.status === 'active' && customPrice?.monthly != null
                                    ? customPrice.monthly
                                    : plan?.gateway?.DNmonthly
                                )}
                              </option>
                              {![REGION.US, REGION.UK].includes(userRegion) ? ( // TODO: Remove UK
                                <option
                                  value={`year-${
                                    customPrice?.status === 'active' && customPrice?.yearly != null
                                      ? customPrice.yearly
                                      : plan?.gateway?.DNyearly
                                  }-${plan?.gateway?.yearly_stripe_prod_id}`}
                                >
                                  Yearly (one-off payment) - $
                                  {addTax(
                                    customPrice?.status === 'active' && customPrice?.yearly != null
                                      ? customPrice.yearly
                                      : plan?.gateway?.DNyearly
                                  )}
                                </option>
                              ) : null}
                            </>
                          ) : (
                            <>
                              <option
                                value={`month-${
                                  customPrice?.status === 'active' && customPrice?.monthly != null
                                    ? customPrice.monthly
                                    : plan?.gateway?.[0]?.DNmonthly
                                }-${plan?.gateway?.[0]?.monthly_stripe_prod_id}`}
                              >
                                Monthly (subscription) - $
                                {addTax(
                                  customPrice?.status === 'active' && customPrice?.monthly != null
                                    ? customPrice.monthly
                                    : plan?.gateway?.[0]?.DNmonthly
                                )}
                              </option>
                              {![REGION.US, REGION.UK].includes(userRegion) ? ( // TODO: Remove UK
                                <option
                                  value={`year-${
                                    customPrice?.status === 'active' && customPrice?.yearly != null
                                      ? customPrice.yearly
                                      : plan?.gateway?.[0]?.DNyearly
                                  }-${plan?.gateway?.[0]?.yearly_stripe_prod_id}`}
                                >
                                  Yearly (one-off payment) - $
                                  {addTax(
                                    customPrice?.status === 'active' && customPrice?.yearly != null
                                      ? customPrice.yearly
                                      : plan?.gateway?.[0]?.DNyearly
                                  )}
                                </option>
                              ) : null}
                            </>
                          )}
                        </select>

                        {errors.plan !== '' && <span className='text-danger'>{errors.plan}</span>}
                      </div>
                    )}

                    {buyNumber?.type !== NUMBER_TYPE.SMS && (
                      <>
                        <div className='heading mt-6 mb-2'>
                          {typeMessageMap[buyNumber?.type as MessageType]}
                        </div>
                        <p className='content-p'>
                          To enable this feature, you’ll need to order a Dedicated Number (DN) using
                          the button below, or reach out directly to your account manager. Please
                          note: Setup may take up to 48 hours to complete. Once activated, the
                          number will automatically be updated.
                        </p>
                      </>
                    )}
                  </div>
                  <WSButton
                    type='submit'
                    className='btn btn-lg m-5 btn-primary fw-500 no_svg d-block ms-auto me-0'
                    onClick={handleClick}
                  >
                    <span className='indicator-label'>
                      {buyNumber?.type !== NUMBER_TYPE.SMS ? 'Place Order' : 'Continue'}
                      <i
                        className='bi bi-chevron-right'
                        style={{
                          marginLeft: '10px',
                        }}
                      ></i>
                    </span>
                  </WSButton>
                </div>
              )}

              {next == 2 && (
                <>
                  <div className='col-lg-7'>
                    <div className='order-summary-wrap'>
                      <div className='row mb-4'>
                        <div className='col-xl-5 col-lg-5 col-md-4 col-sm-6 col-12'>
                          <p className='title'>Number</p>
                        </div>
                        <div className='col-xl-5 col-lg-5 col-md-4 col-sm-6 col-12'>
                          <p className='detail'>
                            {
                              numberList?.find((key: any) => key?._id === buyNumber?.number)
                                ?.audNumber
                            }
                          </p>
                        </div>
                        <div className='col-xl-2 col-lg-2 col-md-4 col-sm-6 col-12 text-start text-xl-end text-lg-end text-md-end'>
                          <button
                            onClick={() => {
                              setNext(1)
                              setBuyNumber({...buyNumber, product: ''})
                              setErrors({})
                            }}
                            className='btn btn-sm btn-icon btn-light btn-active-light-primary'
                          >
                            <span className='svg-icon svg-icon-2'>
                              <svg
                                width='24'
                                height='24'
                                viewBox='0 0 24 24'
                                fill='none'
                                xmlns='http://www.w3.org/2000/svg'
                                className='mh-50px'
                              >
                                <path
                                  opacity='0.3'
                                  d='M21.4 8.35303L19.241 10.511L13.485 4.755L15.643 2.59595C16.0248 2.21423 16.5426 1.99988 17.0825 1.99988C17.6224 1.99988 18.1402 2.21423 18.522 2.59595L21.4 5.474C21.7817 5.85581 21.9962 6.37355 21.9962 6.91345C21.9962 7.45335 21.7817 7.97122 21.4 8.35303ZM3.68699 21.932L9.88699 19.865L4.13099 14.109L2.06399 20.309C1.98815 20.5354 1.97703 20.7787 2.03189 21.0111C2.08674 21.2436 2.2054 21.4561 2.37449 21.6248C2.54359 21.7934 2.75641 21.9115 2.989 21.9658C3.22158 22.0201 3.4647 22.0084 3.69099 21.932H3.68699Z'
                                  fill='currentColor'
                                ></path>
                                <path
                                  d='M5.574 21.3L3.692 21.928C3.46591 22.0032 3.22334 22.0141 2.99144 21.9594C2.75954 21.9046 2.54744 21.7864 2.3789 21.6179C2.21036 21.4495 2.09202 21.2375 2.03711 21.0056C1.9822 20.7737 1.99289 20.5312 2.06799 20.3051L2.696 18.422L5.574 21.3ZM4.13499 14.105L9.891 19.861L19.245 10.507L13.489 4.75098L4.13499 14.105Z'
                                  fill='currentColor'
                                ></path>
                              </svg>
                            </span>
                          </button>
                        </div>
                      </div>
                      <div className='row mb-4'>
                        <div className='col-xl-5 col-lg-5 col-md-4 col-sm-6 col-12'>
                          <p className='title'>Plan</p>
                        </div>
                        <div className='col-xl-5 col-lg-5 col-md-4 col-sm-6 col-12'>
                          <p className='detail'>
                            {buyNumber?.recurring_time.charAt(0).toUpperCase() +
                              buyNumber?.recurring_time.slice(1)}{' '}
                            - ${addTax(buyNumber?.price)}
                          </p>
                        </div>
                        <div className='col-xl-2 col-lg-2 col-md-4 col-sm-6 col-12 text-start text-xl-end text-lg-end text-md-end'>
                          <button
                            onClick={() => {
                              setNext(1)
                              setBuyNumber({...buyNumber, product: ''})
                              setErrors({})
                            }}
                            className='btn btn-sm btn-icon btn-light btn-active-light-primary'
                          >
                            <span className='svg-icon svg-icon-2'>
                              <svg
                                width='24'
                                height='24'
                                viewBox='0 0 24 24'
                                fill='none'
                                xmlns='http://www.w3.org/2000/svg'
                                className='mh-50px'
                              >
                                <path
                                  opacity='0.3'
                                  d='M21.4 8.35303L19.241 10.511L13.485 4.755L15.643 2.59595C16.0248 2.21423 16.5426 1.99988 17.0825 1.99988C17.6224 1.99988 18.1402 2.21423 18.522 2.59595L21.4 5.474C21.7817 5.85581 21.9962 6.37355 21.9962 6.91345C21.9962 7.45335 21.7817 7.97122 21.4 8.35303ZM3.68699 21.932L9.88699 19.865L4.13099 14.109L2.06399 20.309C1.98815 20.5354 1.97703 20.7787 2.03189 21.0111C2.08674 21.2436 2.2054 21.4561 2.37449 21.6248C2.54359 21.7934 2.75641 21.9115 2.989 21.9658C3.22158 22.0201 3.4647 22.0084 3.69099 21.932H3.68699Z'
                                  fill='currentColor'
                                ></path>
                                <path
                                  d='M5.574 21.3L3.692 21.928C3.46591 22.0032 3.22334 22.0141 2.99144 21.9594C2.75954 21.9046 2.54744 21.7864 2.3789 21.6179C2.21036 21.4495 2.09202 21.2375 2.03711 21.0056C1.9822 20.7737 1.99289 20.5312 2.06799 20.3051L2.696 18.422L5.574 21.3ZM4.13499 14.105L9.891 19.861L19.245 10.507L13.489 4.75098L4.13499 14.105Z'
                                  fill='currentColor'
                                ></path>
                              </svg>
                            </span>
                          </button>
                        </div>
                      </div>
                    </div>
                    {cards?.length > 0 && (
                      <>
                        <div className='row mb-10 card_box'>
                          {cards?.map((val: any, index: any) => (
                            <div
                              key={index}
                              onClick={() => {
                                setSuccess(true)
                                val?.id == cardID ? setCardID('') : setCardID(val?.id)
                                setComplete(true)
                              }}
                              className='credit-card visa selectable '
                            >
                              {val?.id == cardID && <div className='checkmark123' />}
                              <span className='fw-bolder fs-4 mb-1 credit-cardholder'>
                                {val?.name}
                              </span>
                              <div className='credit-card-last4 fw-bolder fs-4 mb-2'>
                                {val?.last4}
                              </div>
                              <div className='credit-card-expiry'>
                                Expires {val?.exp_month}/{val?.exp_year}
                              </div>
                            </div>
                          ))}
                        </div>
                      </>
                    )}
                    {cards?.length !== 0 && (
                      <button
                        onClick={() => {
                          setSuccess(false)
                          setCardID('')
                          setComplete(false)
                        }}
                        className='btn-sm btn-primary'
                      >
                        Add New Card
                      </button>
                    )}
                    {(!success || cards?.length == 0) && (
                      <>
                        <div className='mb-5 mt-8'>
                          <label className='form-label fw-bolder text-dark fs-6 mb-3'>
                            Payment Method
                          </label>
                          <div className='d-flex gap-3'>
                            <button
                              type='button'
                              onClick={() => {
                                setPaymentMethod('card')
                                setComplete(false)
                                setBecsComplete(false)
                              }}
                              className={`btn btn-sm ${
                                paymentMethod === 'card' ? 'btn-primary' : 'btn-light-primary'
                              }`}
                            >
                              Credit/Debit Card
                            </button>
                            <button
                              type='button'
                              disabled={!dnGracePeriodEnabled}
                              onClick={() => {
                                setPaymentMethod('au_becs_debit')
                                setComplete(false)
                                setBecsComplete(false)
                              }}
                              className={`btn btn-sm ${
                                paymentMethod === 'au_becs_debit'
                                  ? 'btn-primary'
                                  : 'btn-light-primary'
                              }`}
                              title={
                                !dnGracePeriodEnabled
                                  ? 'AU Bank Account is only available when DN Grace Period is enabled'
                                  : ''
                              }
                            >
                              AU Bank Account (BECS)
                            </button>
                          </div>
                        </div>
                        <fieldset className='FormGroup mt-10 border-0 p-0'>
                          {paymentMethod === 'card' ? (
                            <div className='FormRow'>
                              <input
                                onChange={(e: any) => {
                                  let val = e.target.value

                                  setName(val)
                                  ;/^(?:[A-Za-z]+ ?){1,3}$/.test(val)
                                    ? setError('')
                                    : setError('Please enter valid Name')
                                }}
                                className='form-control form-control-lg form-control-solid w-100 my-3'
                                type='text'
                                placeholder='Card holder name'
                              />
                              <span className='text-danger'>{error}</span>
                              <CardElement
                                onChange={(e) => setComplete(e.complete)}
                                options={CARD_OPTIONS}
                              />
                            </div>
                          ) : (
                            <div className='FormRow'>
                              <input
                                onChange={(e: any) => {
                                  setAccountHolderName(e.target.value)
                                }}
                                className='form-control form-control-lg form-control-solid w-100 my-3'
                                type='text'
                                placeholder='Account holder name'
                                value={accountHolderName}
                              />
                              <input
                                onChange={(e: any) => {
                                  setEmail(e.target.value)
                                }}
                                className='form-control form-control-lg form-control-solid w-100 my-3'
                                type='email'
                                placeholder='Email address'
                                value={email}
                              />
                              <div className='my-3'>
                                <AuBankAccountElement
                                  onChange={(e) => setBecsComplete(e.complete)}
                                  options={AU_BANK_ACCOUNT_OPTIONS}
                                />
                              </div>
                              <div className='alert alert-info mt-3'>
                                <small>
                                  By providing your bank account details and confirming this
                                  payment, you agree to this Direct Debit Request and the Direct
                                  Debit Request service agreement, and authorise Stripe Payments
                                  Australia Pty Ltd ACN 160 180 343 Direct Debit User ID number
                                  507156 ("Stripe") to debit your account through the Bulk
                                  Electronic Clearing System (BECS) on behalf of Cellcast (the
                                  "Merchant") for any amounts separately communicated to you by the
                                  Merchant. You certify that you are either an account holder or an
                                  authorised signatory on the account listed above.
                                </small>
                              </div>
                            </div>
                          )}
                        </fieldset>
                      </>
                    )}
                    <div className='d-flex align-items-end justify-content-end mt-13 pt-7'>
                      <WSButton type='submit' className='btn btn-sm btn-light-primary me-5 fw-500'>
                        <span
                          className='indicator-label'
                          onClick={() => {
                            setNext(1)
                            setBuyNumber({...buyNumber, product: ''})
                            setErrors({})
                          }}
                        >
                          Previous
                        </span>
                      </WSButton>
                      <WSButton type='submit' className='btn btn-sm btn-light-primary me-5 fw-500'>
                        <span
                          onClick={() => {
                            setBuyNumber({
                              type: NUMBER_TYPE.SMS,
                              number: '',
                              product: '',
                              price: 0,
                              recurring_time: '',
                              selected: '',
                            })
                            setNext(1)
                            setErrors({
                              number: '',
                              plan: '',
                            })
                            handleClose()
                          }}
                          className='indicator-label'
                        >
                          Cancel
                        </span>
                      </WSButton>

                      <button
                        disabled={
                          !cardID
                            ? paymentMethod === 'card'
                              ? !(complete && name !== '')
                              : !(becsComplete && accountHolderName !== '' && email !== '')
                            : !cardID
                        }
                        className='btn btn-sm btn-primary fw-500'
                        onClick={handleSubmit}
                      >
                        Pay
                      </button>
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </Modal>
    </>
  )
}

export default VirtualNumbersModal
